import BasicDetailSection from '../../../../../../components/event-preview/BasicDetailSection';
import MoreDetailSection from '../../../../../../components/event-preview/MoreDetailSection';
import TicketNavigationTabs from '../../../../../../components/event-preview/TicketNavigationTabs';
import TicketListingPreview from '../../../../../../components/event-preview/TicketListingPreview';
import useEventPreview from '../../../../../../hooks/useEventPreview';
import EventPreviewSkeleton from '../../../../../../components/event-preview/EventPreviewSkeleton';
import NotFound from '../../../../../../pages/404/NotFound';
import '../../../../../../styles/event-preview/EventPreview.css';

/**
 * 75 -> multi date wihout slot -> event-75
 * 77 -> multi date with slot -> event-77
 * 78 -> single date with slot -> event-78
 * 79 -> continous date -> event-79
 */

// Show event preview page based on user?.id and if event status is drafted. compare user?.id with the event details data (which contains userId). Compare these two user?.id and event status both true then show ui or else show error page.

function EventPreview() {
    const {
        showTicketPreview,
        setShowTicketPreview,
        loading,
        previewData,
        scrollToEventSchedule,
        eventScheduleRef,
        isError
    } = useEventPreview();

    if (isError) {
        return <NotFound />;
    }

    return (
        <section id="event-preview-main-section">
            <div className="main-event-preview-container">
                {loading || !previewData ? (
                    <EventPreviewSkeleton />
                ) : (
                    <>
                        <BasicDetailSection
                            name={previewData?.title}
                            eventType={previewData?.event_type}
                            startDate={previewData?.start_date}
                            startTime={previewData?.start_time}
                            endDate={previewData?.end_date}
                            endTime={previewData?.end_time}
                            schedules={previewData?.schedules}
                            location={previewData?.address}
                            minTicketPrice={previewData?.minTicketPrice}
                            fcs={[
                                previewData?.formats?.[0],
                                previewData?.subcategories?.[0],
                                previewData?.category
                            ]}
                            showTicketPreview={showTicketPreview}
                            setShowTicketPreview={setShowTicketPreview}
                            scrollToEventSchedule={scrollToEventSchedule}
                        />

                        {!showTicketPreview && (
                            <MoreDetailSection previewData={previewData} ref={eventScheduleRef} />
                        )}

                        {showTicketPreview && (
                            <>
                                <TicketNavigationTabs />
                                <TicketListingPreview previewData={previewData} />
                            </>
                        )}
                    </>
                )}
            </div>
        </section>
    );
}

export default EventPreview;
